import { render, staticRenderFns } from "./NgLoad.vue?vue&type=template&id=a2cfd6c4&scoped=true&"
import script from "./NgLoad.vue?vue&type=script&lang=js&"
export * from "./NgLoad.vue?vue&type=script&lang=js&"
import style0 from "./NgLoad.vue?vue&type=style&index=0&id=a2cfd6c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cfd6c4",
  null
  
)

export default component.exports